import Vue from 'vue'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import App from './App.vue'
import DefaultLayout from './layouts/Default.vue'
import DashboardLayout from './layouts/Dashboard.vue'
import router from './router'
import {initAPP} from '@/api/getAppConfig'
import store from './store/index.js'
import VueLazyload from 'vue-lazyload'
import i18n from './lang/lang.js';

import './scss/app.scss';

Vue.use(Antd);
Vue.use(VueLazyload, {
    preload: 1.3,
    loading: 'https://imgxsc.htpai.com/static/imgs/nopic.gif!width200',
    error: 'https://imgxsc.htpai.com/static/imgs/nopic.gif!width200',
});


Vue.config.productionTip = false

Vue.component("layout-default", DefaultLayout);
Vue.component("layout-dashboard", DashboardLayout);

Vue.prototype.$BASE_URL = 'https://ctsdata.htpai.com';
Vue.prototype.$STATIC_URL = 'https://static.htpai.com/jy/static/imageenpc/';
Vue.prototype.$CUR = 'A$';

let app = new Vue({
    store,
    router,
    render: h => h(App),
    i18n
})

initAPP(app);

